import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DefaultCopyField } from "../../components/CopyField/CopyField";
import { LinksCopyField } from "../../components/CopyField/LinksCopyField";
import { format } from "date-fns";
import { Box, CircularProgress, Divider, Grid, Typography, useTheme, } from "@mui/material";
import { Download } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { parseDrawingLinks } from "../../../application/common/utils/drawing-links-helper";
import { RoofAccessMapping } from "../../../application/common/utils/roof-access";
import ContractApi from "../../../infrastructure/api/pages/contract-api";
import WorkPreparationContracts from "../../../infrastructure/api/pages/work-preparation-contracts-api";
import { Layout } from "../../components/Layout/Layout";
import { WorkPreparationBreadCrumb } from "../work-preparation/WorkpreparationBreadCrumb";
import "./WorkPreparationDetail.scss";
export const WorkPreparationDetail = () => {
    const theme = useTheme();
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("id");
    const orderNumber = urlParams.get("orderNumber");
    const { t: translate } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [selectedContract, setSelectedContract] = useState();
    const [copied, setCopied] = useState(false);
    const [loader, setLoader] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState({
        contractName: "",
        contractNumber: "",
        leadNumber: 0,
        companyChamberOfCommerce: "",
        companyName: "",
        companyStreet: "",
        companyHouseNumber: "",
        companyCity: "",
        companyCountry: "",
        contactPersonName: "",
        contactPersonPhoneNumber: "",
        contactPersonEmail: "",
        totalAmountInContractedObjects: 0,
        invoiceCompanyAdditional: "",
        invoiceCompanyChamberOfCommerce: "",
        invoiceCompanyCity: "",
        invoiceCompanyCountry: "",
        invoicePerAddress: "",
        invoiceChamberOfCommercePerAddress: "",
        invoiceCompanyHouseNumber: "",
        invoiceCompanyName: "",
        invoiceCompanyPostalCode: "",
        invoiceCompanyStreet: "",
        companyAdditional: "",
        companyPostalCode: "",
        invoiceEmail: "",
        invoicePhoneNumber: "",
        reference: "",
        invoiceAdminEmail: "",
        department: "",
        ledgerAccount: "",
        objects: [],
        contactObjects: [],
        files: [],
    });
    useEffect(() => {
        setLoading(true);
        if (myParam) {
            ContractApi.getById(myParam).then((response) => {
                setSelectedContract(response.data);
                setCopied(response.data.isCopied);
            });
            WorkPreparationContracts.getWorkPreparationDetails(myParam)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setData(response.data);
                    setLoading(false);
                }
            })
                .finally(() => { });
        }
    }, [myParam]);
    useEffect(() => {
        if (completed && selectedContract) {
            setLoader(true);
            ContractApi.MarkWorkPrepContractToIsCopied(selectedContract.id).then((res) => {
                if (res.status === 200) {
                    setLoader(false);
                    navigate("/workpreparation");
                    toast.success(translate("UpdatedSuccessfully"));
                }
            });
            // });
        }
    }, [completed]);
    const downloadDocument = (documentId, fileName) => {
        WorkPreparationContracts.downloadDocument(documentId)
            .then((response) => {
            if (response.status === 200 && response.data != null) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        })
            .catch((error) => {
            console.error("There was an error downloading the document!", error);
        })
            .finally(() => { });
    };
    return (_jsx(Layout, { children: _jsxs(Grid, { container: true, sx: {
                height: "80vh",
                borderRadius: "24px",
                gap: 2,
                padding: { xs: 1, sm: 1, md: 1.5 },
            }, children: [_jsx(WorkPreparationBreadCrumb, { orderNumber: data.contractNumber, companyName: data.companyName, leadNumber: data.leadNumber, setCompleted: setCompleted, loader: loader, copied: copied, dataLoading: loading }), loading ? (_jsx(Box, { sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "80vh",
                        width: "100%"
                    }, children: _jsx(CircularProgress, { size: 32, color: "inherit" }) })) : (_jsxs(Box, { sx: { maxHeight: "calc(100vh - 200px)", overflowY: "auto" }, children: [_jsxs(Grid, { container: true, sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                                padding: { xs: 1, sm: 1, md: 1.5 },
                                marginBottom: 2,
                                flexDirection: "column",
                                gap: 1,
                            }, size: 12, children: [_jsx(Typography, { variant: "h2", children: translate("Relation") }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("ChamberOfCommerce"), value: data.companyChamberOfCommerce || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Name"), value: data.companyName || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Address"), value: `${data.companyStreet} ${data.companyHouseNumber}${data.companyAdditional} ${data.companyPostalCode} ${data.companyCity}`, fullWidth: true }) }), _jsx(Grid, { size: 12, children: _jsx(Typography, { variant: "h3", children: translate("Contact Gegevens") }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Name"), value: data.contactPersonName || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Email"), value: data.contactPersonEmail || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Phone Number"), value: data.contactPersonPhoneNumber || " ", fullWidth: true }) })] })] }), _jsxs(Grid, { container: true, sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                                padding: { xs: 1, sm: 1, md: 1.5 },
                                marginBottom: 2,
                                flexDirection: "column",
                                gap: 1,
                            }, size: 12, children: [_jsx(Typography, { variant: "h2", children: translate("Quote") }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("ContractName"), value: data.contractName || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Price"), value: data.totalAmountInContractedObjects, fullWidth: true }) })] })] }), _jsxs(Grid, { container: true, sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                                padding: { xs: 1, sm: 1, md: 1.5 },
                                marginBottom: 2,
                                flexDirection: "column",
                                gap: 1,
                            }, size: 12, children: [_jsx(Typography, { variant: "h2", children: translate("Invoice") }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("CompanyName"), value: data.invoiceCompanyName || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("PerAddress"), value: data.invoicePerAddress || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("KVK per adres/beheerder"), value: data.invoiceChamberOfCommercePerAddress || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("ChamberOfCommerce"), value: data.invoiceCompanyChamberOfCommerce || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Address"), value: `${data.invoiceCompanyStreet} ${data.invoiceCompanyHouseNumber}${data.invoiceCompanyAdditional} ${data.invoiceCompanyPostalCode} ${data.invoiceCompanyCity}`, fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Cost Centre"), value: data.department || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Reference Number"), value: data.reference || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("LedgerAccount"), value: data.ledgerAccount || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Invoice Email Address"), value: data.invoiceEmail || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("Invoice Phone Number"), value: data.invoicePhoneNumber || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                xs: 12,
                                                sm: 6,
                                                md: 4
                                            }, children: _jsx(DefaultCopyField, { label: translate("AdminEmail"), value: data.invoiceAdminEmail || " ", fullWidth: true }) })] })] }), _jsxs(Grid, { container: true, sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                                padding: { xs: 1, sm: 1, md: 1.5 },
                                marginBottom: 2,
                                flexDirection: "column",
                                gap: 3,
                            }, size: 12, children: [_jsx(Typography, { variant: "h2", children: translate("Object") }), data.objects.length === 0 ? (_jsx(Typography, { children: translate("No objects present") })) : (data.objects.map((object, index) => {
                                    var _a, _b;
                                    return (_jsxs(Grid, { container: true, sx: {
                                            flexDirection: { sm: "row", md: "column" },
                                            gap: 2
                                        }, children: [_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("ObjectId"), value: object.objectId || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 8
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Object Name"), value: object.name || " ", fullWidth: true }) })] }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Address"), value: ((_a = object.objectFullAddress) === null || _a === void 0 ? void 0 : _a.trim())
                                                                ? object.objectFullAddress
                                                                : `${object.street || ""} ${object.houseNumber || ""}${object.addition || ""} ${object.postalCode || ""} ${object.city || ""}`, fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Number of roof surfaces"), value: object.totalRoofSurfaces, fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Roof Surface Area"), value: object.roofArea, fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Roof access"), value: RoofAccessMapping[(_b = object.roofAccess) !== null && _b !== void 0 ? _b : 0], fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("ProjectNumber"), value: object.projectNumber || "", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Price"), value: object.price, fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 8
                                                        }, children: _jsx(DefaultCopyField, { label: translate("SafetySystems"), value: object.safetySystems || "", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Preferred Month"), value: object.preferredMonth || "", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("InstallationDate"), value: object.installationDate
                                                                ? format(new Date(object.installationDate), "dd-MM-yyyy") // Format date
                                                                : "", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Is Drawing Available"), value: object.isDrawingAvailable || "", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { label: translate("Are there overhead system or vertical system for inspection?"), value: object.isMultiplicativeFactorEnabled || "", fullWidth: true }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { multiline: true, label: translate("InternalComments"), value: object.internalComments || "", fullWidth: true, rows: 3 }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(DefaultCopyField, { multiline: true, label: translate("ExternalComments"), value: object.externalComments || "", fullWidth: true, rows: 3 }) }), _jsx(Grid, { size: {
                                                            xs: 12,
                                                            sm: 6,
                                                            md: 4
                                                        }, children: _jsx(LinksCopyField, { label: translate("Werktekening"), items: parseDrawingLinks(object.drawingLink, object.drawingLinkNames), fullWidth: true }) })] }), _jsx(Divider, { sx: {
                                                    width: "100%",
                                                    height: "1px",
                                                    border: "solid 1px #ced4da",
                                                    marginTop: "1%",
                                                    marginBottom: "1%",
                                                } })] }, index));
                                }))] }), _jsxs(Grid, { container: true, sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                                padding: { xs: 1, sm: 1, md: 1.5 },
                                marginBottom: 2,
                                flexDirection: "column",
                                gap: 1,
                            }, size: 12, children: [_jsx(Typography, { variant: "h3", children: "Daktoegang contact" }), data.contactObjects.length === 0 ? (_jsx(Typography, { children: "Geen daktoegang contacten toegevoegd" })) : (data.contactObjects.map((contactObject, index) => (_jsxs(Grid, { container: true, sx: {
                                        flexDirection: { sm: "row", md: "column" },
                                        marginBottom: 2
                                    }, children: [_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }, children: _jsx(DefaultCopyField, { label: translate("Name"), value: contactObject.name || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }, children: _jsx(DefaultCopyField, { label: translate("Email"), value: contactObject.email || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }, children: _jsx(DefaultCopyField, { label: translate("PhoneNumber"), value: contactObject.phoneNumber || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }, children: _jsx(DefaultCopyField, { label: translate("ContactPersonType"), value: contactObject.contactPersonType || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }, children: _jsx(DefaultCopyField, { label: translate("Instruction"), value: contactObject.instructions || " ", fullWidth: true }) }), _jsx(Grid, { size: {
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 4
                                                    }, children: _jsx(DefaultCopyField, { label: translate("LinkedObjectsIds"), value: contactObject.linkedObjects || " ", fullWidth: true }) })] }), _jsx(Divider, { sx: {
                                                width: "100%",
                                                height: "1px",
                                                border: "solid 1px #ced4da",
                                                marginTop: "1%",
                                                marginBottom: "1%",
                                            } })] }, index))))] }), _jsxs(Grid, { container: true, sx: {
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                                padding: { xs: 1, sm: 1, md: 1.5 },
                                marginBottom: 2,
                                flexDirection: "column",
                                gap: 1,
                            }, size: 12, children: [_jsx(Typography, { variant: "h3", children: translate("Purchase order documents") }), data.files.length === 0 ? (_jsx(Typography, { children: "Geen documenten toegevoegd" })) : (_jsx(Grid, { container: true, sx: {
                                        display: "flex",
                                        gap: 1,
                                        marginTop: 1
                                    }, size: 12, children: data.files.map((document, index) => ((_jsxs(Grid, { className: "selected-file", onClick: () => {
                                            downloadDocument(document.id, document.fileName);
                                        }, children: [_jsx(Typography, { variant: "body2", children: document.fileName }), _jsx(Download, { size: 16 })] }))
                                    //           <Grid item xs={12} sm={6} md={4} key={index}>
                                    //               <Button
                                    //                   variant="contained"
                                    //                   // color="info"
                                    //                   endIcon={<Download size={26} />}
                                    //                   onClick={() => downloadDocument(document.id, document.fileName)}
                                    //                   fullWidth
                                    //               >
                                    // <Typography
                                    // >
                                    //  {document.fileName}
                                    // </Typography>
                                    //               </Button>
                                    //           </Grid>
                                    )) }))] })] }))] }) }));
};
